<div class="kpi-grid mini">
  <div class="kpi-card mini" [class.wide]="item.wide" *ngFor="let item of items">
    <div class="kpi-icon" [ngClass]="item.iconClass">
      <i [class]="item.icon"></i>
    </div>
    <div class="kpi-info">
      <span class="kpi-label">{{ item.label }}</span>
      <strong class="kpi-value" [ngClass]="item.valueClass ?? ''">{{ item.value }}</strong>
    </div>
  </div>
</div>
